// assets/cart-notification.js
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.sectionId = 'cart-notification'; // <-- match the SECTION handle
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const sectionHTML = parsedState.sections?.['cart-notification'];
    if (!sectionHTML) return;

    const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    const keyed = doc.getElementById('cart-notification-product-' + parsedState.key); // <-- no querySelector

    const current = document.getElementById('cart-notification-product');
    if (current) current.innerHTML = keyed ? keyed.innerHTML : '';

    // (optional) update bubble...
    if (this.header) this.header.reveal();
    this.open();
  }

  // IMPORTANT: return SECTION handles here, not inner element IDs
  getSectionsToRender() {
    return [
      { id: this.sectionId },         // 'cart-notification'
      { id: 'cart-icon-bubble' }      // if you use the header bubble
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
